import { AuthHeader, AuthLayout, Button, Checkbox } from "@nabble/ui";
import { useState } from "react";
import { RecoveryCodesPanel } from "../../../components/RecoveryCodesPanel";

/** After enrolling: the recovery codes. The step only advances once the person confirms they saved them. */
export function SaveRecoveryCodesStep({ codes, onContinue }: { codes: string[]; onContinue: () => void }): React.JSX.Element {
  const [confirmedSaved, setConfirmedSaved] = useState(false);
  return (
    <AuthLayout wide step={{ current: 3, total: 4, label: "codes" }}>
      <AuthHeader
        icon="checkCircle"
        iconTone="success"
        title="Save your recovery codes"
        lead="Your second factor is set up. If you lose your device, these codes let you sign in."
      />
      <div className="nb-auth-content">
        <RecoveryCodesPanel codes={codes} />
        <Checkbox label="I've saved them" checked={confirmedSaved} onChange={(e) => setConfirmedSaved(e.target.checked)} />
        <Button label="Continue" size="lg" block iconRight="arrowRight" disabled={!confirmedSaved} onClick={onContinue} />
      </div>
    </AuthLayout>
  );
}
